import React from 'react'
import PropTypes from 'prop-types'

import './Checkbox.scss'

const Checkbox = ({ id, label, checked, onChange, disabled, className }) => {
  const classes = className
  const handleChange = () => !disabled && onChange() 

  return (
    <div
      className={`checkbox-input ${classes}`}
      onClick={handleChange}
    >
      <input
        type="checkbox"
        id={id}
        checked={checked}
        disabled={disabled}
        onChange={() => {}}
      />
      <span className="checkmark" />
      {
        label &&
        <label htmlFor={id} onClick={handleChange}>{label}</label>
      }
    </div>
  )
}

Checkbox.defaultProps = {
  id: '',
  className: '',
  label: null,
  checked: false,
  disabled: false,
  onChange: null,
}

Checkbox.propTypes = {
  id: PropTypes.string,
  className: PropTypes.string,
  label: PropTypes.any,
  checked: PropTypes.bool,
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
}

export default Checkbox



// WEBPACK FOOTER //
// ./src/browser/components/fields/Checkbox.js